// src/services/reportsApi.js
import reportsClient from "./reportsApiClient";

const ALLOWED_MODES = new Set(["preview", "download"]);
const ALLOWED_FORMATS = new Set(["pdf", "pptx"]);

export async function fetchReports() {
  const response = await reportsClient.get("/reports");

  // Esperado:
  // {
  //   count: number,
  //   items: [
  //     {
  //       report_id,
  //       title,
  //       has_pdf,
  //       has_pptx,
  //       ...
  //     }
  //   ]
  // }
  return response.data;
}

export async function requestReportAccess(
  reportId,
  mode,
  format = "pdf"
) {
  const normalizedReportId = String(reportId || "").trim();
  const normalizedMode = String(mode || "").trim().toLowerCase();
  const normalizedFormat = String(format || "").trim().toLowerCase();

  if (!normalizedReportId) {
    throw new Error("reportId es obligatorio.");
  }

  if (!ALLOWED_MODES.has(normalizedMode)) {
    throw new Error("Modo de acceso no permitido.");
  }

  if (!ALLOWED_FORMATS.has(normalizedFormat)) {
    throw new Error("Formato de reporte no permitido.");
  }

  // El PPTX no se intenta abrir dentro del iframe.
  if (
    normalizedMode === "preview" &&
    normalizedFormat !== "pdf"
  ) {
    throw new Error(
      "La vista previa solamente está disponible en PDF."
    );
  }

  const response = await reportsClient.post(
    `/reports/${encodeURIComponent(normalizedReportId)}/access`,
    {
      mode: normalizedMode,
      format: normalizedFormat,
    }
  );

  return response.data;
}
